import { ClassroomProcessing } from '../features/classroom/classroom-processing';
import { SyncContext } from './sync-context-value';
import {
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';
import { SyncEngine, type SyncEngineSnapshot } from './sync-engine';

const EMPTY_SNAPSHOT: SyncEngineSnapshot = {
  records: [],
  conflicts: [],
  status: 'idle',
};

export function SyncProvider({ userId, children }: { userId: string; children: ReactNode }) {
  const engine = useMemo(() => new SyncEngine(userId), [userId]);
  const processing = useMemo(() => new ClassroomProcessing(engine), [engine]);
  const [snapshot, setSnapshot] = useState(EMPTY_SNAPSHOT);

  useEffect(() => {
    const unsubscribe = engine.subscribe(setSnapshot);
    void engine.start();
    void processing.start();
    return () => {
      unsubscribe();
      processing.stop();
      engine.stop();
    };
  }, [engine, processing]);

  return (
    <SyncContext.Provider value={{ engine, snapshot, processing }}>
      {children}
    </SyncContext.Provider>
  );
}

export function useSync() {
  const context = useContext(SyncContext);
  if (!context) throw new Error('useSync 必须在 SyncProvider 中使用');
  return context;
}
